import { NgModule,} from '@angular/core';
import {IonicModule, IonicPageModule} from "ionic-angular";
import {SellionsLayoutRendererLibModule} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/sellions-layout-renderer-lib.module";
import {GenericDataViewService} from "../generic-data-view.service";
import {GenericDataViewTablePage} from "./generic-data-view-table.page";

@NgModule({
  declarations: [GenericDataViewTablePage],
  imports: [
    IonicPageModule.forChild(GenericDataViewTablePage),
    SellionsLayoutRendererLibModule,
    IonicModule],
  entryComponents: [GenericDataViewTablePage],
  providers: [GenericDataViewService],
  exports: [GenericDataViewTablePage]
})
export class GenericDataViewTablePageModule {}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-table/generic-data-view-table.page.module.ts